import { useEffect, useState } from "react";
import { fetchWebpage } from "../../../../api/webpage/pages";
import DashboardHeader from "../../../../components/dashboard/dashboardHeader";
import { useParams, useNavigate } from "react-router-dom";
import { PageBuilder } from "../../../../components/dashboard/webpage/pageBuilder/PageBuilder";
import toast from "react-hot-toast";

export const WebpageEditor = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadPage();
  }, [slug]);

  const loadPage = async () => {
    try {
      setIsLoading(true);
      const response = await fetchWebpage(slug);
      if (response.status === 200 && response.data) {
        setPageData(response.data);
        // Log for debugging
        console.log("Page data loaded:", {
          id: response.data.web_page?.id,
          slug: response.data.web_page?.slug,
          title: response.data.web_page?.title,
        });
      } else {
        console.error("Failed to load page:", response);
        toast.error("Kunne ikke laste side");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error loading page:", error);
      toast.error("Kunne ikke laste side");
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    // Reload page to get updated data (including new version if created)
    await loadPage();
  };

  if (isLoading) {
    return (
      <DashboardHeader
        backUrl="/dashboard/webpage/pages"
        subtitle=""
        actions={[]}
        title={"Webpage Editor"}
        meta={[]}
      >
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">Laster...</div>
        </div>
      </DashboardHeader>
    );
  }

  return (
    <div className="flex flex-col relative">
      <DashboardHeader
        backUrl="/dashboard/webpage/pages"
        subtitle=""
        actions={[]}
        title={`Rediger: ${pageData?.web_page?.title || ""}`}
        meta={[]}
      />
      <div className="flex-1 overflow-hidden relative h-full">
        {pageData?.web_page?.id ? (
          <PageBuilder
            pageId={pageData.web_page.id}
            slug={slug}
            onSave={handleSave}
          />
        ) : (
          <div className="flex items-center justify-center h-full">
            <div className="text-gray-500">Laster side data...</div>
          </div>
        )}
      </div>
    </div>
  );
};
